import '../App.css';
import NavBar from './navbar';
import NavMenu from './navmenu';
import QuoteList from './quotelist';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';

const Quotes = () => {
	return (
		<div className="Home">
			<QuoteList />
			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default Quotes;